import "./styles/Skeleton.scss";

export const GifPreviewPlaceholder = () => <div className="GifPreviewPlaceholder" />;
export const GifBlockPlaceholder = () => <div className="tile GifBlockPlaceholder" />;
export const TilePlaceholder = () => <div className="tileItem GifBlockPlaceholder" />;
export const NicheBlockPlaceholder = () => <div className="NichePreview NicheBlockPlaceholder" />;
